/**
 * 配置项
 * */

// 表盘的配置项
export const gaugeSetting = {
    'Mbps': {
        '100': [0, 5, 10, 15, 20, 30, 50, 75, 100],
        '300': [0, 5, 10, 15, 25, 50, 75, 150, 300],
        '500': [0, 5, 10, 25, 50, 100, 150, 300, 500],
        '1000': [0, 10, 25, 50, 100, 250, 500, 750, 1000],
    },
    'MB/s': {
        '10': [0, 1, 2, 3, 4, 5, 6, 8, 10],
        '30': [0, 1, 2, 3, 4, 5, 8, 15, 30],
        '50': [0, 1, 2, 3, 5, 10, 15, 30, 50],
        '100': [0, 1, 2, 5, 10, 25, 50, 75, 100],
    },
    'kB/s': {
        '5000': [0, 100, 200, 300, 500, 1000, 2000, 3000, 5000],
        '10000': [0, 500, 1000, 1500, 2000, 3000, 5000, 8000, 10000],
        '15000': [0, 500, 1000, 1500, 2000, 3000, 5000, 10000, 15000],
        '30000': [0, 500, 1000, 1500, 2500, 5000, 10000, 15000, 30000],
    }
}



// WEBPACK FOOTER //
// ./resources/js/config/setting.js